import { render, staticRenderFns } from "./SaveComponentManageButton.vue?vue&type=template&id=276bf267"
import script from "./SaveComponentManageButton.vue?vue&type=script&lang=js"
export * from "./SaveComponentManageButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports